export default __webpack_public_path__ + "static/media/texas.b441b835.jpg";